/**
 * by Aleksandar Panic
 **/

import axios from "axios";

const api = axios.create({
    withCredentials: true
});

api.interceptors.response.use(response => response, error => {
    if (error.response && (error.response.status === 403 || error.response.status === 401)) {
        window.location.href = '/';
    } else {
        return Promise.reject(error);
    }

});

const toPath = (endpoint) => `/api/${endpoint.replace(/^\/?(.+)/, '$1')}`; // phpcs:ignore

export const sendGet = (endpoint, params = {}) => api.get(toPath(endpoint), {params});

export const sendPost = (endpoint, body = {}, params = {}) => api.post(toPath(endpoint), body, {params});

export const sendPut = (endpoint, body = {}, params = {}) => api.put(toPath(endpoint), body, {params});

export const sendDelete = (endpoint, params = {}) => api.delete(toPath(endpoint), {params});

export const sendFormData = (endpoint, params = {}) => {
    let formData = new FormData();
    for (let [key, value] of Object.entries(params)) {
        formData.append(key, value);
    }

    const config = {headers: {"Content-Type": "multipart/form-data"}};

    return api.post(toPath(endpoint), formData, {config});
};
